import React, { useEffect } from "react";
import Slider from "react-slick";
import TestimonialTemplate from "./TestimonialTemplate";
import { useDispatch, useSelector } from "react-redux";
import * as TestimonialsActions from "../../../store/salesLandingStore/testimonials/action";
import { Testimonials } from "../../../store/salesLandingStore/testimonials/types";
import { ApplicationState } from "../../../store";

export default function Testimonial() {
    const dispatch = useDispatch();
    const requestTestimonialsFn = () => dispatch(TestimonialsActions.actionCreators.getTestimonials());
    const testimonialsData: Testimonials[] = useSelector((state: ApplicationState) =>
        state.testimonialsState && state.testimonialsState.testimonials ? state.testimonialsState.testimonials : []
    );

    useEffect(() => {
        requestTestimonialsFn();
    }, []);

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1624,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    dot: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dot: false,
                },
            },
        ],
    };

    return (
        <>
            <div className="row">
                <div className="col-10 offset-1">
                    <Slider {...settings}>
                        {testimonialsData.map((data: Testimonials, i: number) => (
                            <div key={i}>
                                <TestimonialTemplate userReview={data} arrayKey={i} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </>
    );
}
